


















































































































































































import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import { loadUser } from '../mapper.coffee'

export default
    props: ['type', 'event'] # login, signup, entering
    data: ->
        isLoading: false
        # typ: ''
        error: ''
        form:
            email: ''
            first_name: ''
            last_name: ''
            address:
                country: ''
    computed:
        countries: -> 
            locale = this.$root.$i18n.locale
            counts = [...this.$countries()]
            index = counts.findIndex (e) -> e[locale]?
            if index > -1
                element = counts[index]
                counts.splice(index, 1)
                counts.unshift(element)
            return counts
    created: ->
        this.form.address.country = Object.keys(this.countries[0])[0]
        # this.typ = this.type
    mounted: ->
        if firebase.auth().isSignInWithEmailLink window.location.href
            this.type = 'entering'
            url = new URL(window.location.href)
            this.form = JSON.parse(localStorage.getItem('auth_form'))
            email = this.form.email
            email = window.prompt(this.$t 'confirm_email') unless email?
            signup = url.searchParams.get('signup') == 'true'
            this.authhenticate(signup)

    methods:
        validate: (signup) ->
            unless /\S+@\S+\.\S+/.test this.form.email then alert(this.$t('invalid_email')); return false
            unless signup == true then return true
            unless this.form.last_name and this.form.first_name and this.form.email# \
            # and this.form.address.country and this.form.address.city \
            # and this.form.address.zip and this.form.address.line
                alert(this.$t 'provide_all_fields')
                return false
            # if this.form.company and not this.form.tax_id then this.error=this.$t('no_tax_id'); return false
            return true

        send_auth_link: (signup) ->
            unless this.validate(signup) then return null
            this.isLoading = true
            localStorage.removeItem('auth_form')
            localStorage.removeItem('auth_event')
            localStorage.setItem('auth_form', JSON.stringify this.form)
            localStorage.setItem('auth_event', this.event)
            settings =
                url: window.location.href + "?signup=#{signup}"
                handleCodeInApp: true
            firebase.auth().languageCode = this.$i18n.locale
            try await firebase.auth().sendSignInLinkToEmail(this.form.email, settings)
            catch e then console.log e; error = e
            finally this.isLoading = false
            this.error = this.$t 'email_sent'

        authhenticate: (signup) ->
            unless this.validate(signup) then return null
            this.error = ''
            this.isLoading = true
        
            u = {}
            auth = firebase.auth()
            try u = await auth.signInWithEmailLink this.form.email, window.location.href
            catch e then this.isLoading = false; alert(e)
            console.log "Auth 👍"

            if signup
                db = firebase.firestore()
                details = JSON.parse(JSON.stringify(this.form))
                delete details.email
                try await db.collection('users').doc(u.user.uid).set(details)
                catch e then console.log e; error = e

                # Save the country code into the auth user object to handle sending emails easier
                # It's a separate function so that the execution doesn't wait for it
                this.updateProfile(details.address.country)

            # loadUser() # after auth, mapper loaded the user details, but it was empty at that time
            alias = localStorage.getItem 'auth_event'
            localStorage.removeItem 'auth_form' unless signup == true
            localStorage.removeItem 'auth_event' unless signup == true
            this.isLoading = false
            this.$router.push { name: 'events' } unless alias != ''

        
        updateProfile: (country) ->
            user = firebase.auth().currentUser
            try await user.updateProfile({displayName: country})
            catch e then console.log e
